export function tabFunction() {
    const buttonParent = $(".tabset");
    const tabButtons = buttonParent.find(".btn");
    const classActive = "active";
    const parentContainer = tabButtons.closest(".tabs-section");
    const tabs = $(parentContainer).find(".tabs");
    const mobileSelect = buttonParent.find(".mobile-view-tab");

    tabButtons.on("click", function (e) {
        if ($(this).closest(".tabs-section").length) {
            e.preventDefault();
            const $this = $(this);
    
            if(!$this.hasClass(classActive)) {
                const activeTab = $this.data("tab");
                $this.siblings(".btn").removeClass(classActive);

                const linkHref = $this.attr("href");
                if (linkHref) {
                    location.hash=linkHref;
                }
    
                $(tabs).slideUp(500, function(){
                    $(tabs).find(".tab").removeClass(classActive);
                    
                    const activeElement = $(`[data-tab="${activeTab}"]`);
                    activeElement.addClass(classActive);
    
                }).slideDown(500);
            }
        }
    });

    mobileSelect.on("change", function (e) {
        const activeTab = $(this).find(":selected").data("tab");
        buttonParent.find(`[data-tab=${activeTab}]`).trigger("click");
    });

    $(window).on("load", function () {
        const hashUrl =  location.hash;

        if(hashUrl) {
            $(`.btn[href$="${hashUrl}"]`).trigger("click");
        } else {
            buttonParent.each((index, parent) => {
                const tabButtons = $(parent).find(".btn");
    
                if(!tabButtons.hasClass(classActive)) {
                    tabButtons.first().trigger("click");
                }
            });
        }
    });
}









// WEBPACK FOOTER //
// ./assets/js/modules/tabFunction.js